import { UnauthorizedError } from "@/utils/auth/UnauthorizedError";

/**
 * 共用 API 錯誤處理。
 * 401（UnauthorizedError）已在攔截器導向登入頁，這裡直接略過 onError，
 * 其餘錯誤交給 onError 處理。
 */
export const handleApiError = (
  error: unknown,
  onError: (error: Error) => void
): void => {
  if (error instanceof UnauthorizedError) return;
  onError(error as Error);
};
